import {
  WSAlert,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { useTeamsManagedByOrganization } from "../../../userFeatures/useTeamsManagedByOrganization";
import { useUserOrganizationName } from "../../../userFeatures/useUserOrganizationName";
import { FilterableTableStakeholders } from "../components/TableStakeholders/FilterableTableStakeholders";
import { routeHelpersAccountStakeholdersAdd } from "../paths";

export const RouteStakeholders: React.FC = () => {
  const hasManagedTeam = useTeamsManagedByOrganization();
  const organizationName = useUserOrganizationName();
  const goToAdd = routeHelpersAccountStakeholdersAdd.useGoTo();

  return (
    <WSPage>
      <WSPageToolbar
        title="Team"
        actions={[
          {
            label: "Add team member",
            buttonKind: "Primary",
            icon: "plus",
            visible: !hasManagedTeam,
            onClick: () => goToAdd()
          }
        ]}
      />

      {hasManagedTeam ? (
        <WSAlert mb="L" theme="info" icon="info-circle">
          Team members are managed by <b>{organizationName}</b> - contact them
          for support.
        </WSAlert>
      ) : null}

      <FilterableTableStakeholders canManage={!hasManagedTeam} />
    </WSPage>
  );
};
